<template>
  <div class="col-3-center">
    <img :src="require('@/assets/fotos/ideenbaum/img1.gif')" alt="img1" />
    <h2>MACH MIT! PARKLET MIT IDEENBAUM</h2>
    <p>Die Stadt Dachau möchte sich für mehr klimafreundliche Mobilität einsetzen. Mit dem letzten Bürgerworkshop wurde auch die erste konkrete Maßnahme seitens der Stadt vorgestellt: das Parklet – eine Art mobile, bepflanzte Sitzgruppe, die auf früheren Parkplätzen der Stadt zum Verweilen einlädt. Es kann schnell auf- oder abgebaut und daher temporär eingesetzt werden. Individuell gestaltet mit Stühlen, Tischen oder Bepflanzungen wird es zu einem nachbarschaftlichen Treffpunkt.</p>
    <p>Das Parklet der Stadt Dachau wird an verschiedenen Orten in der Stadt aufgestellt. Bürger können Kritik und Wünsche in Bezug auf das Thema Mobilität an einen Ideenbaum hängen, der in das Parklet integriert ist. Das Parklet ist eine Umsetzungsidee im Rahmen des Themenfeldes Flanierstadt und ist ein erster Schritt, zusätzlichen Raum für den Fußverkehr zu schaffen und damit eine bessere Aufenthaltsqualität zu erreichen.</p>
    <p>Das Konzept Flanierstadt vereint viele Aspekte, angefangen von Mobilität bis hin zu Stadtgrün. Zu diesem Themenbereich sind viele wertvolle Ideen und Anregungen in den Workshops und in der Online-Beteiligung geäußert worden. In der idealen Flanierstadt haben Fußgänger ausreichend Raum und können sich barrierefrei bewegen. Die öffentlichen Verkehrsmittel sind gut zugänglich. Der Autoverkehr gerät in den Hintergrund. Es gibt immer wieder etwas Neues zu entdecken. Sitzbänke und grüne naturnahe Oasen laden zum Verweilen ein. Kinder erobern sich ihren Raum und können sich ungefährdet und selbstständig bewegen.</p>
    <p>Mit dem Ideenbaum wurde ein Ansatz des Mobilitätsmanagements gestartet. Dieses setzt darauf Änderungen des Mobilitätsverhaltens anzustoßen. Was kann der einzelne Bürger in Zukunft tun, um die Flanierstadt Dachau zum ­Leben zu erwecken? Vielfach wurden durch die Bürger, Wünsche an die Stadt formuliert und weniger Gedanken über das eigene ­Mobilitätsverhalten festgehalten. Folglich ist ein Mobitätsmangement ein wichtiger Baustein, der parallel zu baulichen oder anderen Investitionen ergänzt werden sollte.</p>
    <img :src="require('@/assets/fotos/ideenbaum/img2.jpg')" alt="img2" />
    <!-- <div>
          <Gallery :items="items" />
    </div>-->
  </div>
</template>

<script>
import Anmeldung from "@/components/MachMit/Anmeldung.vue";
import Timeline from "@/components/Timeline.vue";
import Gallery from "@/components/Gallery.vue";

export default {
  components: {
    Anmeldung,
    Timeline,
    Gallery
  },
  data() {
    return {
      items: [
        {
          id: 1
          // src: require("@/assets/fotos/ideenbaum/img1.jpg")
        }
      ]
    };
  },
  methods: {
    showForm() {}
  }
};
</script>
<style scoped lang="scss">
section {
  height: 100%;
}
img {
  width: 100%;
}
</style>
